// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/dealer-tools/:dealer_tools_user_id\",\"regex\":\"^/dealer-tools/([^/]+)$\",\"paramNames\":[\"dealer_tools_user_id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/approuter\"},{\"path\":\"/approuter/agent/territory-insider\"},{\"path\":\"/approuter/andy\"},{\"path\":\"/dealer-tools\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from '@sentry/nextjs';

const ENVIRONMENT = process.env.NODE_ENV || 'development';
const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://3f3890e406354a458007e2e7f3d6b2eb@glitch.carketa.app/4';
const isDev = ENVIRONMENT === 'development';

Sentry.init({
  debug: isDev,
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  // Required since @sentry/nextjs v10.4 to attach user IP addresses.
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
  includeLocalVariables: true,
  ignoreErrors: ["reading 'portalId'", "evaluating 'e.portalId'"],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
